import { createContext } from "react";
const HeadingContext = createContext(false);
export {
  HeadingContext
};
